import axios from 'axios';
import React, {useState, useEffect} from 'react';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';

export const MiPerfilInferior = (props) => {
	const {
		modalBorrrarCuenta,
		setModalBorrrarCuenta,
		modalGuardarCambios,
		setModalGuardarCambios,
		UsuarioCambiar,
		onInputChange,
		modificar,
		setModificar,
	} = props;

	const modificarDatos = () => {
		setModificar(true);
		var inputs = document.getElementsByClassName('inputModificar');
		for (var i = 0; i < inputs.length; i++) {
			inputs[i].disabled = false;
		}
	};

	return (
		<div className='miPerfilInferior'>
			<div className='contentMiPerfilInferior'>
				<div className='datoFormularioUsuarioCambiar'>
					<div className='labelDatoFormUsu'>
						<p>
							Nombre{' '}
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</p>
					</div>
					<div className='valor'>
						<input
							type='text'
							className='inputTextUsuarioCambiar inputModificar'
							name='nombre'
							onChange={(event) => onInputChange(event)}
							value={UsuarioCambiar.nombre}
							disabled
						/>
					</div>
				</div>
				<div className='datoFormularioUsuarioCambiar'>
					<div className='labelDatoFormUsu'>
						<p>
							Apellidos{' '}
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</p>
					</div>
					<div className='valor'>
						<input
							type='text'
							className='inputTextUsuarioCambiar inputModificar'
							name='apellidos'
							onChange={(e) => onInputChange(e)}
							value={UsuarioCambiar.apellidos}
							disabled
						/>
					</div>
				</div>
				<div className='datoFormularioUsuarioCambiar'>
					<div className='labelDatoFormUsu'>
						<p>
							Email{' '}
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</p>
					</div>
					<div className='valor'>
						<input
							type='email'
							name='email'
							className='inputTextUsuarioCambiar inputModificar'
							onChange={(e) => onInputChange(e)}
							value={UsuarioCambiar.email}
							disabled
						/>
					</div>
				</div>
				<div className='datoFormularioUsuarioCambiar'>
					<div className='labelDatoFormUsu'>
						<p>
							Teléfono{' '}
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</p>
					</div>
					<div className='valor'>
						<input
							type='text'
							className='inputTextUsuarioCambiar inputModificar'
							name='telefono'
							onChange={(e) => onInputChange(e)}
							value={UsuarioCambiar.telefono}
							disabled
						/>
					</div>
				</div>
			</div>
			<div className='separador' />
			<div className='buttonsMiPerfil'>
				<div
					className='button borrarCuenta'
					onClick={() => setModalBorrrarCuenta(true)}
					//onClick={() => eliminarPerfil(UsuarioCambiar)}
				>
					<b>Borrar cuenta</b>
				</div>
				<div
					className='button'
					onClick={
						modificar ? () => setModalGuardarCambios(true) : () => modificarDatos()
					}
				>
					<b>{modificar ? 'Guardar' : 'Modificar'}</b>
				</div>
			</div>
		</div>
	);
};
